import {
  SoccerEventStatusId,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'

import { SameTimeIncidentsConfig } from '../../configuration'

export const sameTimeIncidentsConfig: SameTimeIncidentsConfig<
  SoccerIncidentId,
  SoccerEventStatusId
> = {
  excludedIncidents: [
    // bet incidents
    SoccerIncidentId.BookingMarketsDisabled,
    SoccerIncidentId.BookingMarketsEnabled,
    SoccerIncidentId.CornerMarketsDisabled,
    SoccerIncidentId.CornerMarketsEnabled,
    // gameplay incidents
    SoccerIncidentId.Foul,
    SoccerIncidentId.Penalty,
    SoccerIncidentId.FreeKick,
    SoccerIncidentId.Offside,
    SoccerIncidentId.InPossession,
    SoccerIncidentId.Attack,
    SoccerIncidentId.DangerousAttack,
    // status incidents
    SoccerIncidentId.NotStarted,
    SoccerIncidentId.FinishedAwardedWin,
    SoccerIncidentId.Interrupted,
    SoccerIncidentId.Postponed,
    SoccerIncidentId.Abandoned,
    SoccerIncidentId.Cancelled,
    SoccerIncidentId.ToFinish,
    SoccerIncidentId.MatchAboutToStart,
    SoccerIncidentId.KickOff,
    SoccerIncidentId.FirstHalf,
    SoccerIncidentId.StartDelayed,
    SoccerIncidentId.Halftime,
    SoccerIncidentId.SecondHalf,
    SoccerIncidentId.FinishedRegularTime,
    SoccerIncidentId.WaitingForExtratime,
    SoccerIncidentId.ExtratimeFirstHalf,
    SoccerIncidentId.ExtratimeHalftime,
    SoccerIncidentId.ExtratimeSecondHalf,
    SoccerIncidentId.WaitingForPenalty,
    SoccerIncidentId.FinishedAfterExtratime,
    SoccerIncidentId.PenaltyShootoutStarted,
    SoccerIncidentId.FinishedAfterPenalties,
    SoccerIncidentId.AddedTime,
  ],
  excludedIncidentEventStatuses: [SoccerEventStatusId.PenaltyShootout],
}
